export default __webpack_public_path__ + "static/media/wallet-ico.fc625f89.svg";